export const truncateDecimal = (number: string, index = 4): string => {
    let result = number;
    if (number.indexOf('.') > -1) {
      result = number.slice(0, (number.indexOf('.')) + (index + 1));
    }
    if (number.indexOf('.') === number.length - 1) {
      result = number.slice(0, number.indexOf('.'));
    }
    return result;
  };

export function convertToEth(ethToUsdValue:number, price: number, toFixedValue = 4) {
    const ethValue =truncateDecimal(String(+ethToUsdValue / price), toFixedValue);
    return ethValue ?? 0;
  }
